// DS: P19C
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../IconWrap';
const DeviationTypeGif = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        transform: "translate(3 5)"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#06070D",
        opacity: ".24",
        d: "M3 5h18v15H3z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        d: "M20 6v13H4V6h16zM9 9H6v1H5v5h1v1h4v-3H8v1H7v-3h1v1h2v-2H9V9zm4 0h-2v7h2V9zm6 0h-5v7h2v-2h2v-2h-2v-1h3V9z"
    }))));
};
DeviationTypeGif.displayName = 'DeviationTypeGif';
export default DeviationTypeGif;
